import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck, faPen, faTrashCan } from '@fortawesome/free-solid-svg-icons'

import './App.css'
function App() {
  //Tasks States
  const [toDo, setToDo] = useState([
    // { id: 1, title: '1st Task', status: false },
    // { id: 2, title: '2nd Task', status: false }
  ])

  //Temp Taks States
  const [newTask, setNewTask] = useState('')
  const [updateData, setUpdateData] = useState('')

  //Add Task
  const addTask = () => {
    if (newTask) {
      let num = toDo.length + 1;
      let newEntry = { id: num, title: newTask, status: false }
      setToDo([...toDo, newEntry])
      setNewTask('')

    }

  }
  //Delete Task
  const deleteTask = (id) => {
    let newTasks = toDo.filter(task => task.id !== id)
    setToDo(newTasks)

  }
  //Mark Task
  const markDone = (id) => {
    let newTask = toDo.map(task => {
      if (task.id === id) {
        return ({ ...task, status: !task.status })
      }
      return task;
    })
    setToDo(newTask)

  }

  //Cancel Update
  const cancelUpdate = () => {
    setUpdateData('')

  }

  //Change task for update
  const changeTask = (e) => {
    let newEntry = {
      id: updateData.id,
      title: e.target.value,
      status: updateData.status ? true : false
    }
    setUpdateData(newEntry)
  }

  //Update task
  const updatetask = (e) => {
    let filterRecords = [...toDo].filter(task => task.id !== updateData.id)
    let updateObject = [...filterRecords, updateData]
    setToDo(updateObject)
    setUpdateData('')
  }


  return (
    <div className="container App">
      <br /><br />
      <h2>To DO List App</h2>
      <br /><br />

      {/* Update Task */}
      {updateData && 
      <div className="row">
        <div className="col">
          <input
            value={updateData && updateData.title}
            onChange={(e) => changeTask(e)}
            className="form-control form-control-lg" />
        </div>
        <div className="col-auto">
          <button
            onClick={updatetask}
            className="btn btn-lg btn-success mr-20">
            Update
          </button>
          <button onClick={cancelUpdate} className="btn btn-lg btn-warning">
            Cancel
          </button>
        </div>
      </div>
      }
      <br />


      {/* Add New Task */}
      <div className="row">
        <div className="col">
          <input
            value={newTask}
            onChange={(e) => setNewTask(e.target.value)}
            className="form-control form-control-lg"
          />
        </div>
        <div className="col-auto">
          <button
            className="btn btn-lg btn-success"
            onClick={addTask}
          >
            Add Task
          </button>
        </div>
      </div>

      {/* Display Todos */}

      {toDo.length === 0 ? <p className="noTasks"><h3>No tasks found!</h3></p> : ''}
      <br/>
      <br/>
      {toDo && toDo
        .sort((a, b) => a.id > b.id ? 1 : -1)
        .map((task, index) => {
          return (
            <React.Fragment key={task.id}>
              <div className=" col taskbg">
                <div className={task.status ? 'done' : ''}>
                  <span className='taskNumber'>{index + 1}</span>
                  <span className='taskText'>{task.title}</span>
                </div>
                <div className='iconsWrap'>
                  <span title='Completed / Not ' onClick={() => { markDone(task.id) }}>
                    <FontAwesomeIcon icon={faCircleCheck} />
                  </span>

                  {
                    task.status ? null : (
                      <span
                        title='Edit Task'
                        onClick={() => setUpdateData({
                          id: task.id,
                          title: task.title,
                          status: task.status ? true : false
                        })}
                      >
                        <FontAwesomeIcon icon={faPen} />
                      </span>)
                  }

                  <span title='Delete Task' onClick={() => deleteTask(task.id)}>
                    <FontAwesomeIcon icon={faTrashCan} />
                  </span>
                </div>
              </div>
            </React.Fragment>
          )

        })}

    </div>
  )
}


export default App;
